import {
  Box,
  Button,
  Link,
  Modal,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import CheckBox from "../../../../../Supporting files/CheckBox/CheckBox";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";

interface Props {
  open_status: boolean;
  value_update: Function;
  attrName: any;
  section_name: string;
  section_name_attrName: string;
}

const AddNewSectionPopup: React.FC<Props> = ({
  open_status,
  value_update,
  attrName,
  section_name_attrName,
  section_name,
}) => {
  const [addField, setAddField] = React.useState<string>("Personal Details");
  const [addSubSectionField, setAddSubSectionField] =
    React.useState<string>("Personal Details");
  const [tabName, setTabName] = React.useState<string>("Overview");
  const [warnAddField, setWarnAddField] = React.useState<boolean>(false);
  const [mainSecToggle, setMainSecToggle] = React.useState(0);
  const [mainSection, setMainSection] = React.useState("Select");
  const [showSubSection, setShowSubSection] = React.useState(false);
  const [toggle, setToggle] = React.useState(false);

  const mainSection_data = [
    { key: "Select", value: "Select" },
    { key: "Select", value: "Select" },
  ];
  const tabname_data = [
    { key: "Overview", value: "Overview" },
    { key: "Overview", value: "Overview" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
    value_update(section_name_attrName, value);
  };

  const handleClick = () => {
    setToggle(!toggle);
  };

  return (
    <Modal
      open={open_status}
      className="modalWrapper"
      onClose={() => {
        value_update(attrName, false);
      }}
    >
      <Box className="modalInner sm-width">
        <Grid container spacing={2} alignItems="center">
          <Grid xs={2} className="mb-4"></Grid>
          <Grid xs={8}>
            <h2 className="popup-heading">Add New Section</h2>
          </Grid>
          <Grid xs={2} className="text-right">
            <Link
              className="close-button"
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mb-3" justifyContent="center">
          <Grid xs={12} className="radio_group">
            <RadioGroup defaultValue="Skip">
              <FormControlLabel
                value="Skip"
                control={<Radio />}
                label="Main Section"
                onClick={() => setMainSecToggle(0)}
              />
              <FormControlLabel
                value="Overwrite"
                control={<Radio />}
                label="Sub-Section"
                onClick={() => setMainSecToggle(1)}
              />
            </RadioGroup>
          </Grid>
        </Grid>
        {mainSecToggle == 0 ? (
          <Grid container spacing={2} className="mb-3" justifyContent="center">
            <Grid xs={12}>
              <RKTextField
                class_name="inputField"
                title="Section Name"
                value={addField}
                attrName={setAddField}
                value_update={updateMasterState}
                warn_status={warnAddField}
                error_messg="Please enter new section name"
              />
            </Grid>

            <Grid
              xs={12}
              className="switchFields add_tab"
              display={"flex"}
              alignItems="center"
            >
              <span>Add to tab</span>
              <input type="checkbox" className="switch" onClick={handleClick} />
            </Grid>
            <Grid xs={12}>
              <h4 className="tab_noteheading">
                Note: Enabling this features lets you add this particular
                section to the given tab name.
              </h4>
            </Grid>
            {toggle == true ? (
              <Grid xs={12}>
                <SelectDropdown
                  class_name="inputField"
                  title="Select Tab Name"
                  value={tabName}
                  attrName={setTabName}
                  value_update={updateMasterState}
                  dropdown_data={tabname_data}
                  warn_status={false}
                />
              </Grid>
            ) : null}
            <Grid xs={12} className="text-right">
              <Link
                underline="none"
                className="blueBtn addfile"
                onClick={() => setShowSubSection(true)}
              >
                Add Sub Section
              </Link>
            </Grid>
            {showSubSection && (
              <>
                <Grid xs={11}>
                  <RKTextField
                    class_name="inputField"
                    title="Sub-Section Name"
                    value={addSubSectionField}
                    attrName={setAddSubSectionField}
                    value_update={updateMasterState}
                    warn_status={warnAddField}
                    error_messg="Please enter new section name"
                  />
                </Grid>
                <Grid xs={1}>
                  <Link className="redBtn delete ml-0" underline="none"></Link>
                </Grid>
              </>
            )}
          </Grid>
        ) : null}

        {mainSecToggle == 1 ? (
          <Grid container spacing={2} className="mb-3" justifyContent="center">
            <Grid xs={12}>
              <SelectDropdown
                class_name="inputField"
                title="Main Section"
                value={mainSection}
                attrName={setMainSection}
                value_update={updateMasterState}
                dropdown_data={mainSection_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={12}>
              <RKTextField
                class_name="inputField"
                title="Sub-Section Name"
                value={addSubSectionField}
                attrName={setAddSubSectionField}
                value_update={updateMasterState}
                warn_status={warnAddField}
                error_messg="Please enter new section name"
              />
            </Grid>
          </Grid>
        ) : null}

        <Grid container spacing={2}>
          <Grid
            xs={12}
            style={{ textAlign: "center", position: "relative" }}
            className="ctaBtn"
          >
            <Button
              variant="contained"
              className="submitBtn"
              onClick={() => {
                if (section_name.toString().length > 0) {
                  setWarnAddField(false);
                  value_update(attrName, false);
                } else {
                  setWarnAddField(true);
                }
              }}
            >
              Done
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddNewSectionPopup;
